import { ImportApi } from "@/api";

export async function postLesson(payload) {
  await ImportApi.postLesson(payload);
}
